var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none",
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.18555 10.7676C5.32031 10.8965 5.48438 10.9668 5.67188 10.9668C6.06445 10.9668 6.36914 10.6621 6.36914 10.2754C6.36914 10.082 6.29297 9.90625 6.1582 9.77148L2.05664 5.76367L6.1582 1.76758C6.29297 1.63281 6.36914 1.45117 6.36914 1.26367C6.36914 0.876953 6.06445 0.572266 5.67188 0.572266C5.48438 0.572266 5.32031 0.642578 5.19141 0.771484L0.632812 5.22461C0.46875 5.37695 0.386719 5.56445 0.386719 5.76953C0.386719 5.97461 0.46875 6.15039 0.626953 6.30859L5.18555 10.7676ZM10.4238 10.7676C10.5586 10.8965 10.7168 10.9668 10.9102 10.9668C11.3027 10.9668 11.6074 10.6621 11.6074 10.2754C11.6074 10.082 11.5254 9.90625 11.3965 9.77148L7.28906 5.76367L11.3965 1.76758C11.5312 1.63281 11.6074 1.45117 11.6074 1.26367C11.6074 0.876953 11.3027 0.572266 10.9102 0.572266C10.7168 0.572266 10.5586 0.642578 10.4238 0.771484L5.86523 5.22461C5.70703 5.37695 5.625 5.56445 5.61914 5.76953C5.61914 5.97461 5.70117 6.15039 5.86523 6.30859L10.4238 10.7676Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/double-arrow-left.33ddcf0c170a4e179239dd838deded62.svg";
export { ForwardRef as ReactComponent };